import React, { useState } from "react"
import { makeStyles } from "@material-ui/styles"
import { Carousel } from "react-responsive-carousel"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import NavigationArrow from "../../images/navigation arrow.svg"

const useStyles = makeStyles(theme => {
  const button = {
    background: "transparent",
    border: 0,
    margin: 0,
    opacity: 1,
    padding: theme.spacing(0,6),
    '-webkit-tap-highlight-color': 'transparent',
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0,3),
    },
    "&::before": {
      background: "transparent",
      backgroundImage: "url(" + NavigationArrow + ")",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      border: 0,
      height: theme.spacing(3),
      margin: 0,
      width: theme.spacing(3),
    },
  }
  return {
    root: {
      background: '#fff'
    },
    imageWrapper: {
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      overflow: 'hidden'
    },
    carousel: {
      height: '100%',
      //react-responsive-carousel overrides
      "& .carousel": {
        "&.carousel-slider": {
          height: '100%',
          "& .slider-wrapper": {
            height: '100%',
            "& .slider": {
              height: '100%',
              "& .slide": {
                background: "transparent",
                height: '100%',
              },
            },
          },
          "& .control-arrow": {
            ...button,
            "&.control-prev": {
              "&::before": {
                transform: "scaleX(-1)",
              },
            },
          },
        },
        "& img": {
          pointerEvents: "auto",
          verticalAlign: "initial",
        },
      },
    },
    image: {
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'cover',
    },
  }
})

export default props => {
  const classes = useStyles()
  const [slide, setSlide] = useState(0)

  const mapDataToSlides = imageData =>
    imageData.map((image, i) =>
      <div key={i} className={classes.imageWrapper}>
        <img className={classes.image} src={image.src} alt={image.alt} />
      </div>
    )

  return (
    <div data-cy= "image-gallery" className={[classes.root, props.className].join(' ')}>
      <Carousel
        className={classes.carousel}
        onChange={i => {
          setSlide(i)
        }}
        infiniteLoop
        selectedItem={slide}
        showArrows={true}
        showThumbs={false}
        showStatus={false}
        showIndicators={false}
        transitionTime={750}
        useKeyboardArrows
      >
        {mapDataToSlides(props.images)}
      </Carousel>
    </div>
  )
}
